import Loadable from 'react-loadable';

export const RecallApiDoc = Loadable({
  loader: () => import('./RecallApiDoc'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/RecallApiDoc/index.ts